import gql from 'graphql-tag'

import { ChildFieldsFragment } from 'main/gql/child'
import { UserFieldsFragment } from 'main/gql/user'

export const SUBMIT_INTERMEDIATE_PARENT_SIGN_UP_FORM_MUTATION = gql`
  mutation SubmitIntermediateParentSignUpForm($user: UpdateUserParams!, $child: ChildParams!) {
    updateUser(user: $user) {
      ...UserFields
    }
    upsertChild(child: $child) {
      ...ChildFields
    }
  }

  ${ChildFieldsFragment}
  ${UserFieldsFragment}
`
